var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMtStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mt-star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD700",
    d: "M140 201.483l72.1 43.517-19.133-82.017 63.7-55.183-83.883-7.117-32.783-77.35-32.783 77.35-83.883 7.117 63.7 55.183-19.133 82.017 72.1-43.517z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtStar);
export default __webpack_public_path__ + "static/media/mt-star.a7db46a1f828a4866fbdf91a7a90d277.svg";
export { ForwardRef as ReactComponent };